module.exports = __webpack_public_path__ + "img/RelpenMove.080aa3bd.png";